import { useState } from "react";
import "./deepSearch.css";
import mainAxios from "../../../redux/api/mainAxios";
import { useDispatch, useSelector } from "react-redux";
import {
  deepSearchFunction,
  setActiveOnglet,
} from "../../../redux/actions/immobilierActions";
import moment from "moment";
import { redirect } from "react-router-dom";
import { closeModal } from "../../../redux/actions/modalActions";
import toast from "react-hot-toast";

const DeepSearch = () => {
  const { deepSearch, deepSearchLoading } = useSelector(
    (state) => state.immobilierReducer
  );

  const [formData, setFormData] = useState({
    // General section
    usage: null,
    lieu: "",
    dispositif: "",
    zoneFiscale: "",
    statutLot: null,
    dateDajout: null,
    natureMandat: "",
    // Economic section
    budgetMin: null,
    budgetMax: null,
    prixM2Min: null,
    prixM2Max: null,
    rentabilite: null,
    honoraires: null,
    // Lot section
    referenceLot: "",
    nature: null,
    surfaceMin: null,
    surfaceMax: null,
    espaceTotalMin: null,
    espaceTotalMax: null,
    typologieLot: null,
    etage: null,
    annexe: "",
    // Programme section
    programmeParent: "",
    promoteur: "",
    dateDajoutProgramme: null,
    tag: "",
    label: "",
    lotMaximum: null,
  });
  const { user } = useSelector((state) => state.userAuthReducer);

  const dispatch = useDispatch();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const response = await mainAxios.post(
        `${process.env.REACT_APP_ENDPOINT_URL}api/search-histories`,
        {
          data: {
            ...formData,
            user_searchHistory: user.id,
          },
        }
      );
      toast.success("Recherche enregistrée avec succès");
    } catch (error) {
      console.error("Error saving search:", error);
    }
  };
  const getPreviousSearch = async (id) => {
    try {
      const response = await mainAxios.get(
        `${process.env.REACT_APP_ENDPOINT_URL}api/search-histories/${id}`
      );

      setFormData(response.data.data);
    } catch (error) {
      console.error("Error saving search:", error);
    }
  };
  const handleSearch = () => {
    dispatch(deepSearchFunction(formData));
    dispatch(setActiveOnglet("searchResults"));
    redirect("/immobilier");
    dispatch(closeModal());
  };

  return (
    <div className="deep-search-dialog">
      <div className="deep-search-container ">
        <div className="divA item">
          <p className="borderBottom pink semibold fs16 pb-3 ps-4">Général</p>
          <div className="d-flex flex-column px-4 py-3 borderRight h95">
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Usage
              </label>
              <select
                name="usage"
                value={formData.usage}
                onChange={handleInputChange}
                disabled={true}
              >
                <option value="">Tous</option>
                <option value="bureautique">Bureautique</option>
                <option value="residentiel">Résidentiel</option>
              </select>
            </div>

            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Lieu
              </label>
              <input
                type="text"
                name="lieu"
                value={formData.lieu}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Dispositif
              </label>
              <input
                type="text"
                name="dispositif"
                value={formData.dispositif}
                onChange={handleInputChange}
                disabled={true}
              />
            </div>
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Zone fiscale
              </label>
              <input
                type="text"
                name="zoneFiscale"
                value={formData.zoneFiscale}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Statut du lot
              </label>
              <select
                name="statutLot"
                value={formData.statutLot}
                onChange={handleInputChange}
              >
                <option value="optionné">Optionné</option>
                <option value="disponible">Disponible</option>
              </select>
            </div>
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Nouveautés depuis le :
              </label>
              <input
                type="date"
                name="dateDajout"
                value={formData.dateDajout}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Nature du mandat
              </label>
              <input
                type="text"
                name="natureMandat"
                value={formData.natureMandat}
                onChange={handleInputChange}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="divB item">
          <p className="borderBottom pink semibold fs16 pb-3  ps-4">
            Économique
          </p>
          <div className="d-flex flex-column px-4 py-3 borderRight h100">
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Budget
              </label>
              <div className="d-flex align-items-center budget">
                <span className="greyBadge radiusTL5 radiusBL5">De</span>{" "}
                <input
                  type="number"
                  step="1"
                  name="budgetMin"
                  value={formData.budgetMin}
                  onChange={handleInputChange}
                  className="radius-0"
                />
                <span className="greyBadge">à</span>
                <input
                  type="number"
                  step="1"
                  name="budgetMax"
                  value={formData.budgetMax}
                  onChange={handleInputChange}
                  className="radius-0"
                />{" "}
                <span className="greyBadge radiusTR5 radiusBR5">€</span>
              </div>
            </div>
            <div className="d-flex flex-column mb-25">
              <label htmlFor="" className="mb-1">
                Prix au m2
              </label>
              <div className="d-flex align-items-center budget">
                <span className="greyBadge radiusTL5 radiusBL5">De</span>{" "}
                <input
                  type="number"
                  step="1"
                  name="prixM2Min"
                  value={formData.prixM2Min}
                  onChange={handleInputChange}
                  className="radius-0"
                />
                <span className="greyBadge">à</span>{" "}
                <input
                  type="number"
                  step="1"
                  name="prixM2Max"
                  value={formData.prixM2Max}
                  onChange={handleInputChange}
                  className="radius-0"
                />{" "}
                <span className="greyBadge radiusTR5 radiusBR5">€</span>
              </div>
            </div>
            <div className="d-flex gap30">
              {" "}
              <div className="d-flex flex-column">
                <label htmlFor="" className="mb-1">
                  Rentabilité
                </label>
                <div className="d-flex align-items-center ">
                  <input
                    type="number"
                    step="0.01"
                    name="rentabilite"
                    value={formData.rentabilite}
                    onChange={handleInputChange}
                    className="radius-0 radiusTL5 radiusBL5"
                  />{" "}
                  <span className="greyBadge radiusTR5 radiusBR5">%</span>
                </div>
              </div>
              <div className="d-flex flex-column">
                <label htmlFor="" className="mb-1">
                  Honoraires
                </label>
                <div className="d-flex align-items-center ">
                  <input
                    type="number"
                    step="0.01"
                    name="honoraires"
                    value={formData.honoraires}
                    onChange={handleInputChange}
                    className="radius-0 radiusTL5 radiusBL5"
                  />{" "}
                  <span className="greyBadge radiusTR5 radiusBR5">%/pts</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="divC item d-flex flex-column gap10 ">
          <p className="borderBottom pink semibold fs16 pb-3  ps-4">
            Dernières recherches
          </p>
          <div className="d-flex flex-column px-4 py-3 gap10">
            {user.search_histories.length > 0 ? (
              user?.search_histories?.slice(0, 3).map((search, index) => {
                return (
                  <div
                    key={index}
                    className="d-flex flex-column gap10 history_search_unit bg-grey radius5 px-2 py-3"
                    onClick={() => {
                      getPreviousSearch(search.documentId);
                    }}
                  >
                    <p className="fs16 semibold text-capitalize">
                      Recherche crée le: <br />
                      {moment(search.createdAt).format("DD/MM/YYYY")}
                    </p>
                  </div>
                );
              })
            ) : (
              <p className="fs16 semibold text-capitalize">
                Aucune recherche antérieure
              </p>
            )}
            {/*   <SearchHistoryBox /> */}
          </div>
        </div>
        <div className="divD item">
          <p className="pink semibold fs16 pb-3  ps-4 ">Lot</p>
          <div className="d-flex px-4 py-3 borderTop gap30 ">
            <div className="">
              <div className="d-flex flex-column  mb-25">
                <label htmlFor="">Référence du lot</label>
                <input
                  type="text"
                  name="referenceLot"
                  value={formData.referenceLot}
                  onChange={handleInputChange}
                />
              </div>
              <div className="d-flex flex-column  mb-25">
                <label htmlFor="">Nature</label>
                <select
                  name="nature"
                  value={formData.nature}
                  onChange={handleInputChange}
                >
                  <option value="apartment">Appartement</option>
                  <option value="house">Maison</option>
                </select>
              </div>

              <div className="d-flex flex-column mb-25 ">
                <label htmlFor="" className="mb-1">
                  surface
                </label>
                <div className="d-flex align-items-center">
                  <span className="greyBadge radiusTL5 radiusBL5">De</span>{" "}
                  <input
                    type="number"
                    step="0.01"
                    name="surfaceMin"
                    value={formData.surfaceMin}
                    onChange={handleInputChange}
                    className="radius-0"
                  />
                  <span className="greyBadge ">à</span>{" "}
                  <input
                    type="number"
                    step="0.01"
                    name="surfaceMax"
                    value={formData.surfaceMax}
                    onChange={handleInputChange}
                    className="radius-0"
                  />{" "}
                  <span className="greyBadge radiusTR5 radiusBR5">m²</span>
                </div>
              </div>
              <div className="d-flex flex-column mb-25">
                <label htmlFor="" className="mb-1">
                  Surface Pondérée (Totale)
                </label>
                <div className="d-flex align-items-center">
                  <span className="greyBadge radiusTL5 radiusBL5">De</span>{" "}
                  <input
                    type="number"
                    step="0.01"
                    name="espaceTotalMin"
                    value={formData.espaceTotalMin}
                    onChange={handleInputChange}
                    className="radius-0"
                  />
                  <span className="greyBadge">à</span>
                  <input
                    type="number"
                    step="0.01"
                    name="espaceTotalMax"
                    value={formData.espaceTotalMax}
                    onChange={handleInputChange}
                    className="radius-0"
                  />{" "}
                  <span className="greyBadge radiusTR5 radiusBR5">m²</span>
                </div>
              </div>
            </div>
            <div>
              <div className="d-flex flex-column mb-25">
                <label htmlFor="">Typologie</label>
                <select
                  name="typologieLot"
                  value={formData.typologieLot}
                  onChange={handleInputChange}
                >
                  <option value="">Tous</option>
                  <option value="t0">T0</option>
                  <option value="t1">T1</option>
                  <option value="t2">T2</option>
                  <option value="t3">T3</option>
                  <option value="t4">T4</option>
                  <option value="t5">T5</option>
                  <option value="t6">T6</option>
                  <option value="t7">T7</option>
                  <option value="t8">T8</option>
                </select>
              </div>
              <div className="d-flex flex-column mb-25">
                <label htmlFor="">Étage</label>
                <input
                  type="number"
                  name="etage"
                  value={formData.etage}
                  onChange={handleInputChange}
                />
              </div>
              <div className="d-flex flex-column mb-25">
                <label htmlFor="">Annexe</label>
                <input
                  type="text"
                  name="annexe"
                  value={formData.annexe}
                  onChange={handleInputChange}
                  disabled={true}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="divE item">
          <p className="pink semibold fs16 pt-4 pb-3  ps-4">Le programme</p>
          <div className="d-flex px-4 py-3 flex-wrap borderTop gap-3">
            <div className="d-flex flex-column">
              <label htmlFor="">Programme</label>
              <input
                type="text"
                name="programmeParent"
                value={formData.programmeParent}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex flex-column">
              <label htmlFor="">Promoteur</label>
              <input
                type="text"
                name="promoteur"
                value={formData.promoteur}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex flex-column">
              <label htmlFor="">Nouveautés depuis le :</label>
              <input
                type="date"
                name="dateDajoutProgramme"
                value={formData.dateDajoutProgramme}
                onChange={handleInputChange}
              />
            </div>
            <div className="d-flex flex-column">
              <label htmlFor="">Tag</label>
              <input
                type="text"
                name="tag"
                value={formData.tag}
                onChange={handleInputChange}
                disabled={true}
              />
            </div>
            <div className="d-flex flex-column">
              <label htmlFor="">Label</label>
              <input
                type="text"
                name="label"
                value={formData.label}
                onChange={handleInputChange}
                disabled={true}
              />
            </div>
            <div className="d-flex flex-column">
              <label htmlFor="">Lot maximum</label>
              <input
                type="number"
                name="lotMaximum"
                value={formData.lotMaximum}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center gap30 mt-5">
        <button
          className="pink fs16 pink radius5 bg-white outline-0 borderPink px-30 py-10 applySave"
          onClick={handleSave}
        >
          Enregistrer ma recherche
        </button>
        <button
          className="white fs16 pink radius5 bg-pink outline-0 borderPink px-30 py-10 applySearch"
          onClick={handleSearch}
        >
          {deepSearchLoading ? (
            <div className="spinner-border text-primary" role="status"></div>
          ) : (
            "Afficher les résultats"
          )}
        </button>
      </div>
    </div>
  );
};

export default DeepSearch;
